<template>
  <div class="tap-top"><i data-feather="chevrons-up"></i>
    <tapTop />
  </div>
  <div>
    <div></div>
  </div>

  <div class="page-wrapper compact-wrapper" id="pageWrapper">

    <div class="error-wrapper">
      <div class="container">
        <div class="svg-wrapper">
          <error401 />
        </div>
        <div class="col-md-8 offset-md-2">
          <h3>Oops! This Page is Not Found.</h3>
          <p class="sub-content">The page you are attempting to reach is currently not available. This may be because the
            page does not exist or has been moved.</p><router-link class="btn btn-primary" :to="{ path: '/' }">BACK TO
            HOME PAGE</router-link>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import error401 from "./svg/error401Page.vue"
export default {
  components: {
    error401
  }
}
</script>
